import { render, staticRenderFns } from "./actionModal.vue?vue&type=template&id=6b904224&scoped=true"
import script from "./actionModal.vue?vue&type=script&lang=js"
export * from "./actionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b904224",
  null
  
)

export default component.exports